import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { store } from './store'
import Home from './components/home/Home'
import Library from './components/library/Library'
import { DARK, LIGHT, routePaths } from './constants'
import { Provider } from 'react-redux'
import Magazine from './components/magazine/Magazine'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useEffect, useState, useMemo } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import useMediaQuery from '@mui/material/useMediaQuery'
import { PaletteMode } from '@mui/material'
import { getItem, KEY_THEME } from './services/storage'
import { ClientApiContextProvider } from './components/context/ClientApiContextProvider'
import TermsAndConditions from './components/t&c/TermsAndConditions'
import Http404 from './components/404/Http404'

function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const [mode, setMode] = useState<PaletteMode | undefined>(
    getItem(KEY_THEME)
      ? (getItem(KEY_THEME) as PaletteMode)
      : prefersDarkMode
      ? DARK
      : LIGHT
  )
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          background: {
            default: mode === DARK ? '#1d1c1bff' : '#ece8e1ff'
          }
        }
      }),
    [mode]
  )

  useEffect(() => {
    store.subscribe(() => {
      setTimeout(() => {
        setMode(store.getState().settings.theme)
      }, 200)
    })
  }, [])

  return (
    <Provider store={store}>
      <PersistGate persistor={persistStore(store)}>
        <ClientApiContextProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
              <Routes>
                <Route path={routePaths.DEFAULT} element={<Home />} />
                <Route path={routePaths.HOME} element={<Home />} />
                <Route path={routePaths.LOGIN} element={<Home />} />
                <Route path={routePaths.LIBRARY} element={<Library />} />
                <Route path={routePaths.MAGAZINE} element={<Magazine />} />
                <Route
                  path={routePaths.TERMS_AND_CONDITIONS}
                  element={<TermsAndConditions />}
                />
                <Route path="*" element={<Http404 />} />
              </Routes>
            </Router>
          </ThemeProvider>
        </ClientApiContextProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
